export enum OfflineExportsExportTypesEnum {
    CONTACTS = 'CONTACTS',
    LEADS = 'LEADS',
    COMPANIES = 'COMPANIES',
}
